<template>
<div class="console-ban">
  <h1>如果您想继续浏览本站内容</h1>
  <h1>请关闭浏览器的"开发者工具"后点击</h1>
  <a href="/home">回到本站首页</a>
  <h1>谢谢您的配合</h1>
</div>
</template>

<script>
export default {
  name: "index",
}
</script>

<style scoped lang="less">
.console-ban {
  padding-top: 100px;
  text-align: center;
  line-height: 50px;

  h1 {
    font-size: 30px;
  }

  a {
    font-size: 30px;
    text-decoration: underline;
    color: #1E50AE;
    cursor: pointer;
  }
}
</style>